// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"1dd81909","485":"01129b4c","787":"6ac361ff","827":"680220d1","995":"2d6f4a06"}[chunkId] + ".chunk.js";
};